import { enLocale__SkillsChart } from "../../common/skills-chart/locales";
import { enLocale__RightSwitcher } from "../../modules/sunday-top-nav/buttons/right-toggle/locales";
import { enLocale__Navigation } from "../../routes/locales";
import { MergeTranslateKeys } from "../keys";

const messages: MergeTranslateKeys = {
    cardAbout_label: 'About me',
    ...enLocale__SkillsChart,
    ...enLocale__RightSwitcher,
    ...enLocale__Navigation
}

export default messages;